export const assetTypes = {
  "3D": "3D",
  "image": "Image",
  "illustration": "Illustration",
  "vr_image": "VR Image",
  "video": "Video",
  "animation": "2D Animation",
  "audio": "Audio",
  "cg_image": "Cg Image",
  "unity": "Unity"
};
